import React, {useRef, useState} from 'react';
import {QRCodeCanvas} from 'qrcode.react';


import styles from './QRCodeModal.module.css';
import closeButtonHoverImg from "../../static_files/closeButtonHover.svg";
import closeButtonImg from "../../static_files/closeButton.svg";
import goldBg from "../../static_files/buttonBackgroundGold.svg";
import download_icon from "../../static_files/download-2.svg";
import download_icon_hover from "../../static_files/download-2-hover.svg";
import copy_icon from '../../static_files/invite copy.svg';
import copy_icon_hover from '../../static_files/invite copy hover.svg';


function QRCodeModal({isOpen, onClose, referralUrl, referralCode}) {
    const qrRef = useRef(null);
    const [closeButtonHover, setCloseButtonHover] = useState(false);
    const [downloadButtonHover, setDownloadButtonHover] = useState(false);
    const [copyButtonHover, setCopyButtonHover] = useState(false);

    if (!isOpen) return null;

    const handleDownloadQR = () => {
        if (!qrRef.current) return;
        const canvas = qrRef.current.querySelector('canvas');
        if (!canvas) return;

        const pngUrl = canvas
            .toDataURL('image/png')
            .replace('image/png', 'image/octet-stream');

        const downloadLink = document.createElement('a');
        downloadLink.href = pngUrl;
        downloadLink.download = 'KiraTrading_QR.png';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    const handleCopyCode = () => {
        if (referralCode) {
            navigator.clipboard.writeText(referralCode).then(() => {
                console.log('Referral code copied!');
            }).catch(err => {
                console.error('Failed to copy: ', err);
            });
        }
    };

    return (
        <div
            className={styles.modalBackdrop}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    onClose();
                }
            }}
        >
            <div className={styles.modalContainer}>
                <div className={styles.headerRow}>
                    <img onMouseEnter={() => setCloseButtonHover(true)}
                         onMouseLeave={() => setCloseButtonHover(false)}
                         src={closeButtonHover ? closeButtonHoverImg : closeButtonImg} className={styles.closeBtn}
                         onClick={onClose} alt='x'/>

                </div>

                {/*<div className={styles.dividerLine}/>*/}


                <h3 className={styles.subtitle}>Scan QR Code</h3>
                <p className={styles.description}>
                    Scan the QR to join Prisma x
                </p>

                <div className={styles.qrOuterContainer}>
                    <div className={styles.qrWrapper} ref={qrRef}>
                        <QRCodeCanvas
                            value={referralUrl || 'https://app.kira.trading'}
                            size={244}
                            bgColor='#FFFFFF'
                            fgColor='#000000'
                            includeMargin={true}
                            level='M'
                        />
                    </div>
                </div>
                <div style={{display: "flex", justifyContent: 'center', width: '100%'}}>
                    <button
                        className={styles.upgradeButton}
                        onClick={handleDownloadQR}
                        onMouseEnter={() => setDownloadButtonHover(true)}
                        onMouseLeave={() => setDownloadButtonHover(false)}
                        style={{backgroundImage: `url(${goldBg})`}}
                    >
                        Download QR Code<img 
                            style={{background: "transparent", marginLeft: "10px"}} 
                            src={downloadButtonHover ? download_icon_hover : download_icon}
                            alt={"download"}>
                        </img>
                    </button>
                </div>

                <div className={styles.dividerWrapper}>
                    <div className={styles.dividerLine}></div>
                    <span className={styles.dividerText}>Or enter the code manually</span>
                    <div className={styles.dividerLine}></div>
                </div>

                <div className={styles.copyCodeBox}>
                    <span className={styles.codeText}>{referralCode || 'Loading...'}</span>
                    <button
                        className={styles.copyButton}
                        onClick={handleCopyCode}
                        onMouseEnter={() => setCopyButtonHover(true)}
                        onMouseLeave={() => setCopyButtonHover(false)}
                    >
                        <img 
                            style={{background: "transparent", marginRight: "8px"}} 
                            src={copyButtonHover ? copy_icon_hover : copy_icon}
                            alt={"copy"}>
                        </img>
                        Copy Code
                    </button>
                </div>

            </div>
        </div>
    );
}

export default QRCodeModal;